import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';
import { PATH_LOGIN, PATH_CHANGE_PASSWORD, PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST } from 'routing/path'
import { useGetCurrentClientAccountQuery, clientAccountApi } from 'actions/client/client-account-api'

export function useCheckPermissions() {
  const location = useLocation();
	//const { data: currentClientAccount, isLoading: loadCurrentClientAccountInProgress, isFetching: fetchCurrentClientAccountInProgress } = useGetCurrentClientAccountQuery(null, { skip: true } );
  
  const currentClientAccount = useSelector(clientAccountApi.endpoints.getCurrentClientAccount.select()).data;

  /*const currentClientAccountReady = !loadCurrentClientAccountInProgress && !fetchCurrentClientAccountInProgress;
  if (!currentClientAccountReady) {
    return null; // wait for user authorization endpoint
  }
  else*/ if (!currentClientAccount && location.pathname !== PATH_LOGIN) {
    return (
      <Navigate to={PATH_LOGIN} />
    )
  }
  else if (currentClientAccount && currentClientAccount.passwordExpired && location.pathname !== PATH_CHANGE_PASSWORD) {
    return (
      <Navigate to={PATH_CHANGE_PASSWORD} />
    )
  }
  else if (currentClientAccount && location.pathname === PATH_LOGIN) {
    return (
      <Navigate to={PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST} />
    )
  }
  return null; // no redirect needed
}
